import { render, staticRenderFns } from "./TermsStatement.vue?vue&type=template&id=0ba1ea8e&scoped=true&"
import script from "./TermsStatement.vue?vue&type=script&lang=js&"
export * from "./TermsStatement.vue?vue&type=script&lang=js&"
import style0 from "./TermsStatement.vue?vue&type=style&index=0&id=0ba1ea8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba1ea8e",
  null
  
)

export default component.exports